import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import { EV_PATHS } from "src/consts/Routes/Ev";
import PrimaryButton from "src/components/Shared/PrimaryButton";

const Compatibility = () => {
  const { t } = useTranslation("translation");
  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate(EV_PATHS.TERMS);
  };

  return (
    <Stack gap={5}>
      <Text
        text={t("page.evStart.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Stack gap={4}>
        <Stack>
          <Text
            text={"Audi"}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#2E2E2E",
            })}
          />
          <Text
            text={
              "A1, A3, A3 e-tron, A4, A5, A6, A6 e-tron, A7, A8, e-tron, e-tron GT, e-tron S, Q3, Q4 e-tron, Q5, Q6 e-tron, Q7, Q8, Q8 e-tron, RS e-tron (GT), S e-tron (GT), S6 e-tron, SQ6 e-tron, SQ8 e-tron, TT"
            }
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#6E6E6E",
            })}
          />
        </Stack>

        <Stack>
          <Text
            text={"BMW"}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#2E2E2E",
            })}
          />
          <Text
            text="116, 216, 225, 230, 320, 330, 330e, 420, 520, 530, 530e, 545, 550, 740, 745, 745Le, 750, 760, i3, i4, i5, i7, i8, iX, iX1, iX2, iX3, M5, X1, X2, X3 (xDrive30e), X5 (xDrive45e, xDrive50e), XM, Z4"
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#6E6E6E",
            })}
          />
        </Stack>

        <Stack>
          <Text
            text={"Audi"}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#2E2E2E",
            })}
          />
          <Text
            text={
              "A1, A3, A3 e-tron, A4, A5, A6, A6 e-tron, A7, A8, e-tron, e-tron GT, e-tron S, Q3, Q4 e-tron, Q5, Q6 e-tron, Q7, Q8, Q8 e-tron, RS e-tron (GT), S e-tron (GT), S6 e-tron, SQ6 e-tron, SQ8 e-tron, TT"
            }
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#6E6E6E",
            })}
          />
        </Stack>

        <Stack>
          <Text
            text={"BMW"}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#2E2E2E",
            })}
          />
          <Text
            text="116, 216, 225, 230, 320, 330, 330e, 420, 520, 530, 530e, 545, 550, 740, 745, 745Le, 750, 760, i3, i4, i5, i7, i8, iX, iX1, iX2, iX3, M5, X1, X2, X3 (xDrive30e), X5 (xDrive45e, xDrive50e), XM, Z4"
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#6E6E6E",
            })}
          />
        </Stack>

        <Stack>
          <Text
            text={"Audi"}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#2E2E2E",
            })}
          />
          <Text
            text={
              "A1, A3, A3 e-tron, A4, A5, A6, A6 e-tron, A7, A8, e-tron, e-tron GT, e-tron S, Q3, Q4 e-tron, Q5, Q6 e-tron, Q7, Q8, Q8 e-tron, RS e-tron (GT), S e-tron (GT), S6 e-tron, SQ6 e-tron, SQ8 e-tron, TT"
            }
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#6E6E6E",
            })}
          />
        </Stack>

        <Stack>
          <Text
            text={"BMW"}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#2E2E2E",
            })}
          />
          <Text
            text="116, 216, 225, 230, 320, 330, 330e, 420, 520, 530, 530e, 545, 550, 740, 745, 745Le, 750, 760, i3, i4, i5, i7, i8, iX, iX1, iX2, iX3, M5, X1, X2, X3 (xDrive30e), X5 (xDrive45e, xDrive50e), XM, Z4"
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#6E6E6E",
            })}
          />
        </Stack>
      </Stack>

      <PrimaryButton
        onClick={handleNextClick}
        text={t("page.evStart.nextBtnText")}
      />
    </Stack>
  );
};

export default Compatibility;
